import { render, staticRenderFns } from "./recently-viewed-items.vue?vue&type=template&id=744b2982&"
import script from "./recently-viewed-items.vue?vue&type=script&lang=js&"
export * from "./recently-viewed-items.vue?vue&type=script&lang=js&"
import style0 from "./recently-viewed-items.vue?vue&type=style&index=0&id=744b2982&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports